
namespace RioERP.Orders {
    export class OrderProductsColumns {
        static columnsKey = 'Orders.OrderProducts';
    }
}